<template>
  <!-- Inlined (not <img>) so the feather menu/close icons inherit the toggle's currentColor.
       Mirrors images/icons/menu.svg and images/icons/x.svg. -->
  <svg class="MenuIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <template v-if="open">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </template>
    <template v-else>
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'MenuIcon',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.MenuIcon {
  width: 1.125rem;
  height: 1.125rem;
  display: block;
}
</style>
